import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

const routes: Routes = [
  {
    path: "login",
    loadChildren: () => import("./signin/signin.module").then((m) => m.SigninPageModule),
  },
  {
    path: "registro",
    loadChildren: () => import("./signup/signup.module").then((m) => m.SignupPageModule),
  },
  {
    path: "detalhes",
    loadChildren: () => import("./details/details.module").then((m) => m.DetailsPageModule),
  },
  {
    path: "senha",
    loadChildren: () => import("./forget/forget.module").then((m) => m.ForgetPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountPageRoutingModule {}
